import { zodResolver } from "@hookform/resolvers/zod";
import { Button, MenuItem } from "@mui/material";
import { ReactElement } from "react";
import { useForm } from "react-hook-form";
import z from "zod";

import theme from "~frontend/theme";

import { FlexBox } from "../FlexBox";
import { RhfSelect } from "../forms/react-hook-form-components";
import { ANALYTICS_EMBED_TIMEFRAME_OPTIONS, Timeframe } from "./timeframes";

export function AnalyticsDashboardControls({
  timeframe,
  onSubmit,
  disabled,
}: {
  timeframe: Timeframe;
  onSubmit: (newTimeframe: Timeframe) => Promise<void>;
  disabled?: boolean;
}): ReactElement {
  const { control, handleSubmit } = useForm({
    resolver: zodResolver(
      z.object({
        timeframe: z.enum(
          ANALYTICS_EMBED_TIMEFRAME_OPTIONS.map(option => option.value) as [
            Timeframe,
            ...Timeframe[],
          ]
        ),
      })
    ),
    defaultValues: { timeframe },
  });

  return (
    <FlexBox sx={{ gap: theme.spacing(2) }}>
      <RhfSelect
        secondary
        name="timeframe"
        control={control}
        label="Campaign Start Date"
        sx={{ minWidth: "200px" }}
        disabled={disabled}
      >
        {ANALYTICS_EMBED_TIMEFRAME_OPTIONS.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </RhfSelect>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit(values => onSubmit(values.timeframe))}
        disabled={disabled}
      >
        Update Results
      </Button>
    </FlexBox>
  );
}
